// extracted by mini-css-extract-plugin
var _1 = "MoBjglUP";
var _2 = "MoBjglUP";
export { _1 as "wine-style", _2 as "wineStyle" }
